import {
  CreateTaxAndFeeRequest,
  TaxAndFeeSetting,
  UpdateTaxAndFeeRequest,
} from "../types/admin";
import { ApiResponse } from "../types/common";

import apiClient from "./apiClient";

export const getTaxAndFeeSettings = async (
  isActive?: boolean
): Promise<ApiResponse<TaxAndFeeSetting[]>> => {
  const queryParam = isActive !== undefined ? `?isActive=${isActive}` : "";
  const response = await apiClient.get(`/admin/taxes-fees${queryParam}`);
  return response.data;
};

export const createTaxAndFeeSetting = async (
  data: CreateTaxAndFeeRequest
): Promise<ApiResponse<TaxAndFeeSetting>> => {
  const response = await apiClient.post("/admin/taxes-fees", data);
  return response.data;
};

export const updateTaxAndFeeSetting = async (
  id: string,
  data: UpdateTaxAndFeeRequest
): Promise<ApiResponse<TaxAndFeeSetting>> => {
  const response = await apiClient.put(`/admin/taxes-fees/${id}`, data);
  return response.data;
};

export const deleteTaxAndFeeSetting = async (
  id: string
): Promise<ApiResponse<object>> => {
  const response = await apiClient.delete(`/admin/taxes-fees/${id}`);
  return response.data;
};

// Get active tax and fee settings for checkout (public endpoint)
export const getActiveTaxAndFeeSettings = async (): Promise<
  ApiResponse<TaxAndFeeSetting[]>
> => {
  const response = await apiClient.get("/Payment/active-tax-and-fee-settings");
  return response.data;
};
